import { format } from 'date-fns'
import { dateOffsetString } from '../api/date-calculations'
import {
  assignController, selectAll, select, click,
} from '../api/element-manipulation'


import Pikaday from '../api/pikaday'

assignController('dateRangePicker', (element) => {
  const startDisplay = select(element, '[data-hook~="dateRangePicker.startDisplay"]')
  const startButton = select(element, '[data-hook~="dateRangePicker.startButton"]')
  const endDisplay = select(element, '[data-hook~="dateRangePicker.endDisplay"]')
  const endButton = select(element, '[data-hook~="dateRangePicker.endButton"]')
  const container = select(element, '[data-hook~="dateRangePicker.container"]')
  const startField = select(element, '[data-hook~="dateRangePicker.startField"]')
  const endField = select(element, '[data-hook~="dateRangePicker.endField"]')
  const dateToText = date => format(date, 'LLL d yyyy')
  const formatDate = date => format(date, 'yyyy-LL-dd')
  let startDate
  let endDate
  const onStartSelect = (event) => {
    const date = startPicker.getDate()
    startDisplay.textContent = dateToText(date)
    startDate = date
    startPicker.setStartRange(startDate)
    endPicker.setStartRange(startDate)
    endPicker.setMinDate(startDate)
    startPicker.hide()
  }
  const onEndSelect = (event) => {
    const date = endPicker.getDate()
    endDisplay.textContent = dateToText(date)
    endDate = date
    startPicker.setEndRange(endDate)
    startPicker.setMaxDate(endDate)
    endPicker.setEndRange(endDate)
    endPicker.hide()
  }
  const startOpened = (event) => {
    if (endPicker) endPicker.hide()
  }
  const endOpened = (event) => {
    if (startPicker) startPicker.hide()
  }
  const i18n = {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  }
  const startPicker = new window.Pikaday({
    field: startField,
    onSelect: onStartSelect,
    trigger: startButton,
    container,
    reposition: false,
    i18n,
    onOpen: startOpened,
    format: 'YYYY-MM-DD',
    toString: formatDate,
  })
  const endPicker = new window.Pikaday({
    field: endField,
    onSelect: onEndSelect,
    trigger: endButton,
    container,
    reposition: false,
    i18n,
    onOpen: endOpened,
    format: 'YYYY-MM-DD',
    toString: formatDate,
  })
  if (element.dataset.startSelected) {
    startDate = new Date(element.dataset.startSelected + dateOffsetString)
    startPicker.setDate(startDate)
    setTimeout(onStartSelect, 100)
  }
  if (element.dataset.endSelected) {
    endDate = new Date(element.dataset.endSelected + dateOffsetString)
    endPicker.setDate(endDate)
    setTimeout(onEndSelect, 100)
  }
})
